import pricePanelConfig from '../features/products/price-panel/routes/sidebarConfig';
import ratingSystemConfig from '../features/products/rating-system/routes/sidebarConfig';
import ticketSystemConfig from '../features/products/ticket-system/routes/sidebarConfig';

import { useAuth } from '../authProvider';
import { licPermissoes } from '../service/licenciamento/permissoes';
import pizzasConfig from '../features/products/pizzas/routes/sidebarConfig';

const useProductsConfig = () => {
  const { roles } = useAuth();

  const pricePanel = roles.includes('Price_Panel');
  const robot = licPermissoes(roles).cliente.read;
  const ratingSystem = roles.includes('Rating_System');
  const ticketSystem = roles.includes('Ticket_System');
  const pizzaSystem = roles.includes('Pizza_System');

  const productsConfigArr = [];

  if (pricePanel || robot) {
    productsConfigArr.push(pricePanelConfig({ pricePanel, robot }));
  }
  if (ratingSystem) {
    productsConfigArr.push(ratingSystemConfig());
  }
  if (ticketSystem) {
    productsConfigArr.push(ticketSystemConfig());
  }

  if (pizzaSystem) {
    productsConfigArr.push(pizzasConfig());
  }


  return productsConfigArr;
};

export default useProductsConfig;
